import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.91 5h-6.754a1.1 1.1 0 0 0-.716.268L5.998 10h13-.004.004c.034-.002.303-.018.555-.145q.15-.075.247-.182A1.1 1.1 0 0 0 20 9V6.091A1.09 1.09 0 0 0 18.91 5M2.744 10.179l-.084.077c-.399.27-.661.726-.661 1.244v5.41A4.09 4.09 0 0 0 6.09 21h11.82A4.09 4.09 0 0 0 22 16.911V6.091A3.09 3.09 0 0 0 18.91 3h-6.754c-.745 0-1.466.27-2.028.758zM15 13a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_window_filled-DqA5HRMJ.js.map
